import useOrderReport from '../../api/admin-main/admin-main-hooks';
import CountryStatCard from './country-stat-card';
import axios from 'axios';
import { baseURL } from '../../api/baseURL';
import Cookies from 'js-cookie';
import { useQuery } from 'react-query';
import { SellingStatistics } from './selling-statistics';
import { Image } from 'antd';
import amanalBannerAdmin from '../../assets/amanal-banner-admin.png';

const getOrderReportTurkey = async () => {
    const { data: turkeyOrder } = await axios.get(
        `${baseURL}amantrans/order_turkey/orders/report`,
        {
            headers: {
                Authorization: `Bearer ${Cookies.get('token')}`,
            },
        },
    );

    return turkeyOrder;
};
const AdminMainPage = ({ translation, language }) => {
    const { data } = useOrderReport();
    const turkeyOrder = useQuery(['turkey-main'], getOrderReportTurkey);




    return (
        <div
            style={{
                margin: '0 auto',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Image src={amanalBannerAdmin} preview={false} style={{ padding: '2rem 6rem' }} />
            <SellingStatistics language={language} translation={translation} />
            <CountryStatCard
                turkeyOrder={turkeyOrder}
                language={language}
                translation={translation}
                data={data}
            />
        </div>
    );
};
export default AdminMainPage;
